import { Lit3formBlock, html } from '@Root/lib/lit-3form-block';
import { logErrorToSentry } from '../../../helpers/helpers';
import {
  getTokenFromMetaTag as getCSRFToken,
  HEADER_PARAM as CSRF_HEADER_PARAM,
} from '@Helpers/csrf';

import '@Root/lib/lit-3form-block/components/cta-button';

import { styles } from './css';
export class DirectGroupIndex extends Lit3formBlock {
  static get characterName() {
    return 'direct-group-index';
  }

  static get characterStyles() {
    return [...styles];
  }

  static properties = {
    _submitButtonDisabled: { type: Boolean },
    _groupId: { type: String },
  };

  constructor() {
    super();
    this._submitButtonDisabled = false;
  }

  render() {
    return html`
      <div class="block-wrapper">
        <div class="block-grid direct-group-layout">
          ${this.hasGroups ? this.htmlWithGroups : this.htmlWithoutGroups}
        </div>
      </div>
    `;
  }

  get htmlWithGroups() {
    return html`
      <div class="groups">
        <div class="groups-heading">
          <h1>${this.headerText}</h1>
          <span class="group-code">
            <p>${this.submitInputPromptText}</p>
            ${this.submitCodeHTML}
          </span>
        </div>
        <div class="groups-list">
          ${this.groupsList.map(group => {
            return html`
              <a class="group-wrapper" href="${group.products_url}">
                <img
                  src="${this.imagebossUrl(group.image_url, null, '250')}"
                  alt="${group.display_name || group.products_url}"
                />
              </a>
            `;
          })}
        </div>
      </div>
    `;
  }

  get htmlWithoutGroups() {
    return html`
      <h1 class="no-groups-header">3form Direct</h1>
      <div class="no-groups-body">
        <p class="description">${this.descriptionText}</p>
        <div class="input-prompt">
          <p>${this.submitInputPromptText}</p>
          ${this.submitCodeHTML}
          <p>${this.submitInputHelpText}</p>
        </div>
      </div>
    `;
  }

  get submitCodeHTML() {
    return html`
      <span class="submit-input-wrapper">
        <input
          type="text"
          id="newGroupId"
          name="newGroupId"
          placeholder="${this.submitPlaceholderText}"
          .value="${this._groupId || ''}"
          @input="${this.onGroupIdInput}"
        />
        <cta-button
          class="submit-button"
          cta-data=${this.submitCtaData}
          ?disabled="${!this._groupId || this._submitButtonDisabled}"
          @click="${this.trySubmitNewGroup}"
        ></cta-button>
      </span>
    `;
  }

  get groupsList() {
    return this.content.direct_groups || [];
  }

  get hasGroups() {
    return !!this.groupsList.length;
  }

  get headerText() {
    return this.content.heading || 'My Groups';
  }

  get descriptionText() {
    return this.content.description || '';
  }

  get submitCtaData() {
    return JSON.stringify({
      text: 'Submit',
      isPrimary: true,
      fullWidth: true,
    });
  }

  get submitPlaceholderText() {
    return this.content.input_placeholder || 'Code';
  }

  get submitInputPromptText() {
    return this.content.input_prompt || 'Enter your group code';
  }

  get submitInputHelpText() {
    return this.content.input_help_text || '';
  }

  onGroupIdInput(e) {
    this._groupId = e?.target?.value;
  }

  trySubmitNewGroup() {
    if (this._groupId) {
      this.addNewGroup();
    }
  }

  addNewGroup() {
    const headers = { 'Content-Type': 'application/json' },
      data = {
        method: 'POST',
        headers,
        body: JSON.stringify({ direct_group_code: this._groupId }),
      };

    headers[CSRF_HEADER_PARAM] = getCSRFToken();

    this._submitButtonDisabled = true;
    this.requestUpdate();

    fetch('/direct/add', data)
      .then(response => {
        if (response.ok) {
          return response.json();
        }
      })
      .then(json => {
        this._submitButtonDisabled = false;
        this.updateOrCreateDirectCodesCookie();
        this.requestUpdate();
      })
      .catch(error => {
        this.handleRequestError(error);
      });
  }

  handleRequestError(error = {}) {
    this._submitButtonDisabled = false;
    this.requestUpdate();
    logErrorToSentry(error);
  }

  updateOrCreateDirectCodesCookie() {
    const name = '_3form_direct_codes';
    const cookiesArr = decodeURIComponent(document.cookie).split('; ');
    const currentDirectCookie = cookiesArr.find(v => v.includes(name));

    if (currentDirectCookie && this._groupId) {
      const oldCookieValue = currentDirectCookie.split('=')[1];
      if (!oldCookieValue.includes(this._groupId)) {
        document.cookie = `${name}=${oldCookieValue},${this._groupId};path=/direct`;
      }
    } else {
      document.cookie = `${name}=${this._groupId};path=/direct`;
    }

    // reload page to show results
    location.reload();
  }
}
DirectGroupIndex.defineElement();
